export {}

const leafletsGroups = document.querySelectorAll<HTMLElement>(".s-leaflets__group")

leafletsGroups.forEach((group) => {
  group.addEventListener("initLeafletsGroup", () => {
    console.log("initLeafletsGroup")
    const leaflets = group.querySelectorAll<HTMLElement>(".i-leaflet")
    console.log(leaflets)
    if (group.classList.contains("--active")) {
      leaflets.forEach((leaflet) => {
        leaflet.dispatchEvent(new Event("initLeaflet"))
      })
    }
  })
})
